import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import styles from './AlertModal.module.css';

const AlertModal = ({ show, onHide, title, message }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className={styles.modal}
    >
      <Modal.Header closeButton className={styles.header}>
        <Modal.Title>
          <FaExclamationTriangle className="me-2 text-warning" />
          {title || 'Aviso'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer className={styles.footer}>
        <Button variant="primary" onClick={onHide} className={styles.button}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModal;
